export class Address {
    streetName: string
    streetNumber: string
    boxNo: string
    city: string
    postalCode: string
    country: string
    constructor() {
        this.boxNo = ''
        this.city = ''
        this.country = ''
        this.postalCode = ''
        this.streetName = ''
        this.streetNumber = ''
    }
}


// WEBPACK FOOTER //
// ./src/app/bean/address.ts